(ns frontend.ui.component.lp-portal.report.body.invest-europe.holding.exit.pdf.view
  (:require
   [common.util :as cu]
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.component.block-table.pdf-view :as block-table-pdf]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view :as horizontal-table-pdf]
   [frontend.ui.component.lp-portal.report.component.overview-figures.pdf-view :as overview-figures-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :refer [card]]
   [potpuri.core :as potpuri]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.fund-overview :refer
    [empty-chart-data?
     empty-table-data?]]))

(defn- exit-info-figures
  [{:keys [investment-info]}]
  (block-table-pdf/table investment-info))

(defn headcount-chart-exit
  [data]
  (let [figures (-> data
                    :headcount-exit
                    :figures)]
    (when-not (empty-chart-data? data :headcount-exit)
      [(card
        "Headcount"
        {:svg    (chart-view/chart-svg "highcharts"
                                       (potpuri/deep-merge figures
                                                           {:chart {:width     450
                                                                    :height    300
                                                                    :spacing   [10 0 50 0]
                                                                    :marginTop 10}
                                                            :legend {:verticalAlign "top"
                                                                     :align         "center"
                                                                     :floating      true
                                                                     :padding       0}}))
         :width  250
         :height 150}
        (text-content/optional-footer (:headcount-exit data)))])))

(defn financial-performance-chart-exit
  [data]
  (let [figures (-> data
                    :financial-performance-exit
                    :figures)]
    (when-not (empty-chart-data? data :financial-performance-exit)
      [(card
        "Financial performance"
        {:svg    (chart-view/chart-svg "highcharts"
                                       (potpuri/deep-merge figures
                                                           {:chart  {:width     450
                                                                     :height    300
                                                                     :spacing   [10 0 50 0]
                                                                     :marginTop 20}
                                                            :legend {:verticalAlign "top"
                                                                     :align         "center"
                                                                     :floating      true
                                                                     :padding       0}}))
         :width  250
         :height 150}
        (text-content/optional-footer (:financial-performance-exit data)))])))

(defn exit-company-page-3-columns
  [data]
  (let [{:keys [holding-name equity-grants-loans-exit overview
                highlight-figures-exit]}
        data]
    (page/page
     (page/third-column-background-full-height-not-rounded)
     (page/page-title-with-line {:fund-name  (:fund-name data)
                                 :page-title
                                 (str holding-name " - Exited investment")
                                 :toc-item   true})
     (column/columns
      [(card
        ""
        (text-content/rich-content (->> overview
                                        :case-overview
                                        :rich-content)))]
      [(headcount-chart-exit data)
       (financial-performance-chart-exit data)
       (card
        (if-not (empty-table-data? data :equity-grants-loans-exit) "Total funding" "")
        (horizontal-table-pdf/table equity-grants-loans-exit))
       (when-not (empty-table-data? data :equity-grants-loans-exit)
         (text-content/optional-footer equity-grants-loans-exit))]
      [(exit-info-figures overview)
       (text-content/optional-footer (:investment-info overview))
       (overview-figures-pdf/table (:figures highlight-figures-exit) 2)]))))

(defn exit-pages
  [data]
  (when-not (cu/blank-value? (:reference-date data))
    (concat [(exit-company-page-3-columns data)])))
